import type { ISchedulerTask } from '@interfaces/IScheduler';

/**
 * The number each check carries as the site reads the list: checks count up,
 * guidance between them does not. Keyed by item id, for items already in
 * display order.
 */
export function checkOrdinals(items: readonly { id: string; kind: 'check' | 'description' }[]): Map<string, number> {
  const ordinals = new Map<string, number>();
  items.filter((item) => item.kind === 'check').forEach((item, index) => ordinals.set(item.id, index + 1));
  return ordinals;
}

/** `1.` for a check, nothing for guidance. */
export const ordinalLabel = (ordinal: number | undefined): string => (ordinal === undefined ? '' : `${ordinal}.`);

/**
 * Whose checklist the Edit tab shows. Once the task is committed it is the
 * LOADED task's — the commit and every amendment land there, never in the
 * draft taken when the drawer opened. Before that it is the draft's; a draft
 * taken while the task was committed, then taken back, is not committed.
 */
export function checklistSubject(draft: ISchedulerTask, tasks: readonly ISchedulerTask[]): ISchedulerTask {
  const loaded = tasks.find((task) => task.id === draft.id);
  return loaded?.committed ? loaded : { ...draft, committed: false };
}
